import React from 'react'
import './index.css';
import bechir_icon from "./srcMedia/bechir_icon.png";
import { Link } from 'react-router-dom';

export default function Logo() {
    return (
        <Link to="/" className='logoBar'>
            <img src={bechir_icon} alt='Bechir Dridi' />
            <div className='logo-text'>
                <div className='logo-name'>Bechir Dridi</div>
                <div className='logo-role'>Full Stack & GenAI</div>
            </div>
        </Link>
    )
}
